import type { TabsPayload } from "../types";

export const getItemsInRow = ({
  settings,
  length,
}: {
  settings: TabsPayload;
  length: number;
}) => {
  let itemsInRow =
    settings.tabsPerRow === "auto"
      ? Math.min(5, length)
      : (settings.tabsPerRow as number);
  if (["left", "right"].includes(settings.tabsLayout)) itemsInRow = 1;
  return itemsInRow;
};
